import React from 'react';
import { X, Percent } from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

const DiscountModal = ({
  isOpen,
  onClose,
  discountPercent,
  setDiscountPercent,
  isProcessing,
  onApply
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold text-gray-900 flex items-center">
            <Percent className="w-5 h-5 mr-2 text-orange-600" />
            Apply Discount
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <div className="mb-6">
          <Label htmlFor="discountPercent">Discount Percentage</Label>
          <div className="relative mt-1">
            <Input
              id="discountPercent"
              type="number"
              min="1"
              max="100"
              value={discountPercent}
              onChange={(e) => setDiscountPercent(e.target.value)}
              placeholder="10"
              className="pr-8"
            />
            <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">%</span>
          </div>
          <p className="text-sm text-gray-500 mt-2">
            Enter a percentage between 1 and 100
          </p>
        </div>

        <div className="flex gap-3">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            onClick={onApply}
            disabled={isProcessing || !discountPercent}
            className="flex-1 bg-orange-600 hover:bg-orange-700"
          >
            {isProcessing ? 'Applying...' : 'Apply Discount'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DiscountModal;
